
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class CPMRestService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.cpm_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_CPM_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }

  static readCriticalPathManagementTemplate(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readCriticalPathManagementTemplate",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCriticalPathManagementTemplatePageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCriticalPathManagementTemplatePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static lockCriticalPathManagementCode(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "lockCriticalPathManagementCode",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockCriticalPathManagementCode(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "unLockCriticalPathManagementCode",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static createCriticalPathManagement(input, responseCallBack, errorCallBack) {
    this.method(
      "createCriticalPathManagement",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCriticalPathManagement(input, responseCallBack, errorCallBack) {
    this.method(
      "readCriticalPathManagement",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCriticalPathManagement(input, responseCallBack, errorCallBack) {
    this.method(
      "updateCriticalPathManagement",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCriticalPathManagementPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCriticalPathManagementPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initCriticalPathManagementModule(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "initCriticalPathManagementModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static approveCriticalPathManagement(input, responseCallBack, errorCallBack) {
    this.method(
      "approveCriticalPathManagement",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApproveCriticalPathManagement(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAndApproveCriticalPathManagement",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static updateAndApproveCriticalPathManagement(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateAndApproveCriticalPathManagement",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static unApproveCriticalPathManagement(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "unApproveCriticalPathManagement",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unApproveAndUnLockCriticalPathManagement(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "unApproveAndUnLockCriticalPathManagement",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getCriticalPathManagementTemplates(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCriticalPathManagementTemplates",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static forceCloseCriticalPathManagement(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "forceCloseCriticalPathManagement",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static forceCloseAndUnLockCriticalPathManagement(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "forceCloseAndUnLockCriticalPathManagement",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.cpm_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
             ServiceExecutorProxy.executeService(methodName, input,this.cpm_data_url,responseCallBack, errorCallBack);

    }
  }
}
